export default import.meta.ROLLUP_FILE_URL_QpgE5473N2lL7bogB9e07w